export default __webpack_public_path__ + "static/O0203-5acee6b0478b550af5f712c501dacbad.png";